/* INTEGY V717 — image-ready / image-failure guard for missing Shopify media. */
(function () {
  'use strict';
  function update(img, good) {
    if (!img || !img.matches || !img.matches('[data-integy-v716-legacy-image]')) return;
    img.removeAttribute('data-integy-v717-image-pending');
    img.hidden = !good;
    var wrap = img.closest('[data-integy-v716-legacy-image-wrap]');
    var placeholder = wrap && wrap.querySelector('[data-integy-v716-legacy-placeholder]');
    if (placeholder) placeholder.hidden = !!good;
  }
  document.addEventListener('error', function (event) { update(event.target, false); }, true);
  document.addEventListener('load', function (event) { update(event.target, true); }, true);
  function inspectLoaded() {
    document.querySelectorAll('[data-integy-v716-legacy-image]').forEach(function (img) {
      if (img.complete) update(img, img.naturalWidth > 0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inspectLoaded, { once: true });
  else inspectLoaded();
})();
